import React from "react";

import { Tooltip } from "@fronterahealth/frontera-ui-components";

import { STATUS_DEFINITIONS } from "@components/StatusLegendTooltip/StatusLegendTooltip";

interface Props {
  status: string;
  children: React.ReactElement;
}

// Wraps a status pill (StatusTag, Badge, etc.) with a hover tooltip that shows
// the definition for the given status. No-ops when the status has no entry in
// STATUS_DEFINITIONS (e.g. transient AI-generation states), so safe to wrap
// unconditionally.
export const StatusDefinitionTooltip: React.FC<Props> = ({ status, children }) => {
  const def = STATUS_DEFINITIONS[status];
  if (!def) return children;
  return (
    <Tooltip
      placement="bottom"
      showInfoIcon={false}
      text={
        <div className="max-w-[280px] text-left">
          <div className="text-xs font-semibold leading-tight">
            {status}
            {def.qualifier ? <span className="ml-1 font-normal text-limestone-300">({def.qualifier})</span> : null}
          </div>
          <div className="mt-1 text-xs leading-snug">{def.description}</div>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
};
